import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const rolesApi = createApi({
  reducerPath: "rolesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,

    validateStatus: (response) => {
      if (response.status === 401) {
        window.location.href = "/login";
        return false;
      } else if (response.status >= 200 && response.status < 300) {
        return true;
      } else {
        throw new Error(`HTTP error ${response.status}`);
      }
    },
  }),
  endpoints: (builder) => ({
    getAllRoles: builder.mutation({
      query: () => ({
        url: "/v1/userservice/api/user/getAllActiveRole",
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    getRoleById: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/getAllActiveRole",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    createRole: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/createRole",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    updateRole: builder.mutation({
      query: (body) => ({
        url: `/v1/userservice/api/user/updateRole`,
        method: "PUT",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    deleteRole: builder.mutation({
      query: (body) => ({
        url: `/v1/userservice/api/user/deactiveRole`,
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
  }),
});

export const {
  useGetAllRolesMutation,
  useCreateRoleMutation,
  useGetRoleByIdMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolesApi;
